<template>
    <div class="item" :style="{ backgroundColor: background, width: width }">
        <div class="text" :style="{fontSize: fontSizes[0]+'px', color: color}">{{ text }}</div>
        <div class="value" :style="{fontSize: fontSizes[1]+'px', color: color}">{{ format(value) }}</div>
    </div>
</template>

<script>

export default {
    name: 'SocialItem',
    props: {
        text: String,
        value: [String, Number],
        fontSizes: [],
        formatType: {
            type: String,
            default: 'formatThousand'
        },
        type: {
            type: String,
            default: 'number'
        },
        percentFormat: {
            type: Boolean,
            default: false
        },
        background: String,
        color: String,
        width: {
            type: String,
            default: '100%'
        },
        isPositive: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        format(value) {
            if (this.percentFormat) {
                if (this.type === 'number') {
                    switch(this.formatType) {
                        case 'formatThousand':
                            return this.formatThousand(value);
                        case 'formatDecimal':
                            return this.formatDecimal(value);
                    }
                } else {
                    return this.formatPercent(value, 4)
                }
            } else {
                switch(this.formatType) {
                    case 'formatThousand':
                        return this.formatThousand(value);
                    case 'formatDecimal':
                        return this.formatDecimal(value);
                }
            }
            
        },
        formatThousand(value) {
            value = value ? value.toString() : '';
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(value))
                value = value.replace(pattern, "$1.$2");
            return value;
        },
        formatDecimal(value) {
          return value ? ((value < 0 && this.isPositive) ? '0' : value.toFixed(2).replace('.', ',')) : '0';
        },
        formatPercent(value, fraction) {
            return (value ? `${value.toFixed(fraction || 2)}` : '0') + '%';
        }
    }
}
</script>
<style scoped>
.item {
    border-radius: 10px;
    padding-top: 3px;
    width: 100%;
    border: var(--main-color) 1px solid;
    height: 75px;
}

.text {
  font-weight: 400;
  text-align: center;
  color: var(--chart-area-bg-color);
}

.value {
  font-weight: 600;
  text-align: center;
  color: var(--chart-area-bg-color);
}
</style>